var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7483 1V3.89904M3.93137 14.5288C3.93137 9.69712 4.90849 3.89904 11.7483 3.89904C18.5882 3.89904 19.5653 9.69712 19.5653 14.5288C19.5653 19.3606 22.4967 22.2596 22.4967 22.2596H1C1 22.2596 3.93137 19.3606 3.93137 14.5288ZM15.6568 22.2596C15.6568 22.2596 15.6568 26.125 11.7483 26.125C7.83986 26.125 7.83986 22.2596 7.83986 22.2596H15.6568Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell-icon.a85b67075b3fbdb93f0735c1cf15184c.svg";
export { ForwardRef as ReactComponent };